import React, { useState } from 'react';

const About = () => {
  const [activeTab, setActiveTab] = useState('skills');

  const opentab = (tabname) => {
    setActiveTab(tabname);
  };

  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="about-col-1">
            <img src="images/oo.png" alt="About Me" width="450" height="450" />
          </div>
          <div className="about-col-2">
            <h1 className="subtitle">About Me</h1>
            <p>
              I am a Computer Science aspirant currently in sophomore year of my university.
              I am skilled in multiple languages including Python, C++ etc. I also have
              a good hold over Web Development.
            </p>
            <div className="tab-title">
              <p className={`tab-links ${activeTab === 'skills' ? 'active-link' : ''}`} onClick={() => opentab('skills')}>Skills</p>
              <p className={`tab-links ${activeTab === 'experience' ? 'active-link' : ''}`} onClick={() => opentab('experience')}>Experience</p>
              <p className={`tab-links ${activeTab === 'education' ? 'active-link' : ''}`} onClick={() => opentab('education')}>Education</p>
            </div>
            <div className={`tab-contents ${activeTab === 'skills' ? 'active-tab' : ''}`} id="skills">
              <ul>
                <li><span>SEO Specialist</span><br />Onpage and Offpage SEO</li>
                <li><span>Technical Writer</span><br />Writing technical content for all sorts of topics</li>
                <li><span>Web Development</span><br />Designing Web/App interface</li>
              </ul>
            </div>
            <div className={`tab-contents ${activeTab === 'experience' ? 'active-tab' : ''}`} id="experience">
              <ul>
                <li><span>2023 - Current</span><br />Intern at Devupix</li>
                <li><span>2019 - Current</span><br />Freelance Work</li>
              </ul>
            </div>
            <div className={`tab-contents ${activeTab === 'education' ? 'active-tab' : ''}`} id="education">
              <ul>
                <li><span>2022</span><br />Bachelors in Computer Science at Air University</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
